import { ProFormCascader as OriginalProFormCascader } from '@ant-design/pro-components';
import { withWrap } from '../../utils/hoc';
export default withWrap(OriginalProFormCascader);
